import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import Chart from "react-apexcharts";
import Config from "../Config";
function Enquirypie({dashboarddata}) {
  //   const [options, setOptions] = useState({
  //     labels: ["Previous week", "This week"],
  //   });

  var options = {
    colors: ["#9933ff", "#6600cc"],

    labels: ["Enquiry", "Converted project"],
    fill: {
      colors: ["#9933ff", "#6600cc"],
    },
    stroke: {
      colors: ["#9933ff", "#6600cc"],
    },
    markers: {
      colors: ["#3cb371", "#6a5acd"],
    },
    title: {
      text: "No of Enquiry  vs Converted project",
      align: "left",
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize: "14px",
        fontWeight: "400",
        fontFamily: undefined,
        color: "#fff",
        marginTop: "12px",
      },
    },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 90,
        offsetY: 10,
      },
    },
    grid: {
      padding: {
        bottom: -80,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };
  return (
    <div className="blogpie">
      <Chart
        options={options}
        type="pie"
        series={[dashboarddata.enquiryCount, dashboarddata.projectsCount]}
        color="white"
        height="300px"
      />
    </div>
  );
}

export default Enquirypie;
